import {RuntimeConfiguration} from './RuntimeConfiguration';

const configuration = new RuntimeConfiguration(new Map());

export {configuration, type RuntimeConfiguration};
